import React from 'react';
import Request from './Request';
import HowItWorks from './HowItWorks';
import FormExample from './FormExample';
import PriceList from './PriceList';
import ProceedSection from './ProceedSection';
import FAQ from './FAQ';

const MedicalFormArea = () => {
  return (
    <>
      <section id="medicalform-area">
        <div className="container">
          <Request />
          <HowItWorks />
          <FormExample />
          <PriceList />
          <ProceedSection />
          <FAQ />
        </div>
      </section>
    </>
  );
};

export default MedicalFormArea;
